import React, { useEffect } from "react";
import gsap from "gsap";

import { useParams } from "react-router-dom";
import "./index.scss";

import mockup from "mockup";
import DetailCard from "components/DetailCard";
import DetailNext from "components/DetailNext";
import BackCloseButton from "components/BackCloseButton";

import background from "assets/background/background-datail-cocktail.webp";
import DrinkResponsibly from "../../components/DrinkResponsibly";

const Detail = () => {
  let { id } = useParams();

  const cocktail = mockup.find(({ id: dataId }) => dataId === id);

  const fadeElements = [
    ".detail-caption",
    ".video",
    ".detail-next",
    ".cards .detail-card",
  ];

  useEffect(() => {
    gsap
      .timeline()
      .to(fadeElements, {
        opacity: 0,
        duration: 0,
      })
      .to([".detail-caption", ".video", ".detail-next"], {
        opacity: 1,
        stagger: 0.1,
      })
      .to(".cards .detail-card", {
        opacity: 1,
        stagger: 0.05,
        delay: -0.2,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="detail page"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <BackCloseButton navigationPath="/menu" />

      {cocktail && (
        <>
          <div className="detail-content col-8">
            <div className="detail-caption">
              <h1 className="heading-huge accent-underline">
                {cocktail.title}
              </h1>
              <p className="heading-5 detail-description">
                {cocktail.description}
              </p>
            </div>
            <div className="cards">
              <DetailCard type="ingredients" data={cocktail} />
              <DetailCard type="originalRecipe" data={cocktail} />
              <DetailCard type="serving" data={cocktail} />
            </div>
          </div>
          <div className="media-container col-5">
            {cocktail.video && cocktail.poster ? (
              <video
                className="media video"
                src={require(`assets/video/cocktails/${cocktail.video}`)}
                poster={require(`assets/video/cocktails/poster/${cocktail.poster}`)}
                autoPlay
                muted
                loop
              />
            ) : (
              <img
                className={`media img ${cocktail.name}`}
                src={require(`assets/img/${cocktail.img}`)}
                alt={cocktail.title}
              />
            )}
          </div>
          <DetailNext
            id={+id! === mockup.length ? "1" : (+id! + 1).toString()}
          />
        </>
      )}

      <DrinkResponsibly />
    </div>
  );
};

export default Detail;
